
<div>
  <poppins-text-field
    id="first-name"
    v-model="form.firstName"
    labelName="First name"
    aria-label="First Name"
    name="firstName"
    type="text"
    class="mb-16"
    autocomplete="given-name"
    :status="formStatuses.firstName"
    :helperText="helperText(formStatuses.firstName, 'firstName')"
    @blur="validateRequiredFields('firstName', form.firstName)"
  />
  <poppins-text-field
    id="last-name"
    v-model="form.lastName"
    labelName="Last name"
    aria-label="Last Name"
    name="lastName"
    type="text"
    class="mb-16"
    autocomplete="family-name"
    :status="formStatuses.lastName"
    :helperText="helperText(formStatuses.lastName, 'lastName')"
    @blur="validateRequiredFields('lastName', form.lastName)"
  />
  <poppins-email-text-field
    id="email"
    ref="emailTextField"
    v-model="form.email"
    labelName="Email"
    name="email"
    class="mb-16"
    :status="formStatuses.email"
    :helperText="helperText(formStatuses.email, 'email')"
    @update:status="updateStatus($event, 'email')"
  />
  <poppins-password-text-field
    id="password"
    ref="passwordTextField"
    v-model="form.password"
    labelName="Password"
    name="password"
    class="mb-16"
    :status="formStatuses.password"
    autocomplete="new-password"
    @blur="validatePassword"
  />
  <poppins-text-field
    id="zipcode"
    v-model="form.zipcode"
    labelName="ZIP code"
    name="postal-code"
    type="text"
    maxlength="5"
    pattern="[0-9]*"
    class="mb-24"
    inputmode="numeric"
    aria-label="Five-digit zip code"
    :status="formStatuses.zipcode"
    :helperText="helperText(formStatuses.zipcode, 'zipcode', form.zipcode)"
    :limit-input-to-pattern="true"
    @blur="validateZipcode"
  />
</div>
